import React, { useState, useEffect } from 'react';
import OptionsList from "./OptionsList";
import { fetch, fullPath, pick } from "../../modules/utils";
export default function FilteredSelect({ pathPrefix, filters, errors, handlePropagation, onChange }) {
    const [currentFilterIndex, setCurrentFilterIndex] = useState(0);
    const [filterState, setFilterState] = useState({});
    const fetchData = (index, state) => { const currentFilter = filters[index]; const path = `${pathPrefix}/${currentFilter.path}`; const queryObject = pick(state, currentFilter.params); fetch('GET', fullPath(path, queryObject), 'application/json', 'application/json').then(data => { setFilterState(prev => ({ ...prev, [`${currentFilter.name}Data`]: data })); }).catch(e => { if (e) {
        console.error('Fetch failed: ' + e);
    } }); };
    useEffect(() => { fetchData(currentFilterIndex, filterState); }, []);
    const indexOfFilterByName = name => { return filters.map(filter => filter.name).indexOf(name); };
    const handleFilterPropagation = (name, value) => {
        const selectedIndex = indexOfFilterByName(name);
        let newFilterIndex = Math.min(selectedIndex + 1, filters.length - 1);
        let finalValue = value;
        if (value === 'Other') {
            finalValue = '';
            newFilterIndex = selectedIndex;
        }
        const newState = { ...filterState, [name]: finalValue };
        setFilterState(newState);
        setCurrentFilterIndex(newFilterIndex); // Propagate to parent
        if (handlePropagation) {
            if (typeof handlePropagation === 'function') {
                handlePropagation(name, finalValue);
            }
        }
        if (onChange) {
            onChange({ [name]: finalValue });
        }
        if (selectedIndex + 1 <= filters.length - 1) {
            fetchData(newFilterIndex, newState);
        }
    };
    const lists = [];
    for (let i = 0; i <= currentFilterIndex; i++) {
        const filter = filters[i];
        const data = filterState[`${filter.name}Data`];
        if (!data || data.length === 0)
            continue;
        let options;
        let selections;
        if (filter.popularOptions) {
            selections = data.filter(option => filter.popularOptions.indexOf(option) === -1).map(string => ({ label: string, value: string }));
            if (filter.selectDefault) {
                selections.unshift({ label: filter.selectDefault, value: '' });
            }
            options = filter.popularOptions.map(string => ({ label: string, value: string }));
        }
        else {
            options = data.map(string => ({ label: string, value: string }));
        }
        if (i > 0) {
            lists.push(/*#__PURE__*/ React.createElement("hr", { key: i * 2 - 1 }));
        }
        lists.push(/*#__PURE__*/ React.createElement(OptionsList, { options: options, selections: selections, name: filter.name, error: errors && errors[filter.name], resourceName: filter.name, questionHeading: filter.heading, questionText: filter.text, modifiers: ['columns'], value: filterState[filter.name], handlePropagation: handleFilterPropagation, key: i * 2 }));
    }
    return lists;
}
